export default {
	matching: 'Eşleştirme'
}